var testiThumbs = new Swiper(".product-thumbnails", {
    loop: false,
    slidesPerView: 1.15,
    spaceBetween: 15,
    grabCursor: true,
    centeredSlides: true,
    breakpoints: {
        992: {
            slidesPerView: 1.22,
            centeredSlides: false,
            spaceBetween: 16
        }
    }
});

var testiMain = new Swiper(".product-carousel", {
    loop: false,
    slidesPerView: 1,
    allowTouchMove: true,
    grabCursor: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    }
});

testiMain.on('slideChangeTransitionStart', function() {
    testiThumbs.slideTo(testiMain.activeIndex);
});

testiThumbs.on('transitionStart', function(){
    testiMain.slideTo(testiThumbs.activeIndex);
});